import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { EventManager } from '@ms/core/service/event-manager.service';
import { Observable, Subscription } from 'rxjs';
import { logRequest } from 'app/main/shared/http-utils';
import { FastReport } from '@ms/core/shared/fast-report.model';
import { convertRequest } from '../shared/utils';
import { DialogService } from '@ms/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class ReportService implements OnDestroy {
    baseUrl = '/report-service/api';

    subs: Subscription;
    constructor(
        private http: HttpClient,
        private em: EventManager,
        private dialogService: DialogService,
        private translate: TranslateService
    ) {}

    init() {
        if (this.subs) {
            this.subs.unsubscribe();
            this.subs = null;
        }
        this.subs = this.em.subscribe('report-ready', result => {
            console.log('MESSAGE', result);
            this.getReport(result.message.metaData.reportId).subscribe(response => {
                console.log('REPORT', response);
                const blob = new Blob([response.body], { type: 'application/pdf' });
                const downloadURL = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadURL;
                link.download = result.message.title;
                link.click();
            });
        });
    }

    getReport(reportId: string): Observable<HttpResponse<any>> {
        return this.http.get(`${this.baseUrl}/report/${reportId}`, {
            observe: 'response',
            responseType: 'blob',
            headers: logRequest(),
        });
    }

    fastReportExcel(json: FastReport<any>, fileName: string) {
        console.log('DATA', json);
        json = convertRequest(json);
        const body = {
            data: JSON.stringify(json),
        };
        this.http
            .post(`${this.baseUrl}/fast-report/generate-excel`, body, {
                observe: 'response',
                responseType: 'blob',
                headers: logRequest(),
            })
            .pipe(this.dialogService.observe(this.translate.instant('GENERAL.MESSAGE.INFO.PLEASE_WAIT_PROCESSING')))
            .subscribe(response => {
                const blob = new Blob([response.body], { type: 'application/ms-excel' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${fileName}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    }

    fastReportPdf(json: FastReport<any>, fileName: string) {
        console.log('DATA', json);
        json = convertRequest(json);
        const body = {
            data: JSON.stringify(json),
        };
        this.http
            .post(`${this.baseUrl}/fast-report/generate-pdf-via-excel`, body, {
                observe: 'response',
                responseType: 'blob',
                headers: logRequest(),
            })
            .pipe(this.dialogService.observe(this.translate.instant('GENERAL.MESSAGE.INFO.PLEASE_WAIT_PROCESSING')))
            .subscribe(response => {
                const blob = new Blob([response.body], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${fileName}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
}
